import { Injectable } from '@angular/core';

import {
  LoanApplicationsStates,
  PersonalLoanApplicationResponse,
  GetBorrowerResponse
} from '../../../../models';
import LoanPurpose = PersonalLoanApplicationResponse.LoanPurposeEnum;

import { PersonalLoansSessionDataModel } from '../models/personal-loans-session-data.model';


export enum SessionScenario {
  UserOriginated = <any> 'UserOriginated',
  AgentOriginated = <any> 'AgentOriginated'
}

@Injectable()
export class PersonalLoanSessionService {
  // Data that is saved to session storage
  public set data(value: PersonalLoansSessionDataModel) {
    this._data = value;
    this._data.setSessionData(value);
  }
  public get data(): PersonalLoansSessionDataModel {
    return this._data;
  }

  constructor(private _data: PersonalLoansSessionDataModel) {
    const existingSession = this.data.getSessionData();
    if (!existingSession) {
      this.data = _data;
    } else {
      this.data.populate(existingSession);
    }
  }

  public resetLoanApplication(): void {
    this.data.clear();
  }
}
